import React, { Component } from 'react'

export default class Footer extends Component { 
  render() {
    return (
      <footer>
        <img src="Web_usda_nifa_horizontal_rgb_72.jpg" style={{display:"inline-block", width:"234px", height:"auto", verticalAlign:"middle"}} alt="NIFA" />
        <span style={{display:"inline-block", marginLeft:"1em", padding:"8px", width:"50%", fontSize:"75%", verticalAlign:"middle"}}>This website was developed and is managed by the Northeast Regional Climate Center, located at Cornell University. 
            This website is based on work supported through grant number 2017-70006-27210 from the National 
            Institute of Food and Agriculture, Crop Protection and Pest Management, Applied Research and Development Program.</span>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Footer.js